import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Color, FontStyle } from "../../constants";
import { useSelector } from "react-redux";
import SidebarChatPreview from "./SidebarChatPreview";
import chatIcon from "../../img/icons8/chat.png";

const px = 2;

const MessagesSidebar = () => {
  const [sortedChats, setSortedChats] = useState([]);
  const messages = useSelector((state) => state.messages);
  const allChats = messages.allChats;
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (allChats === null) return;
    const newChats = [...allChats].sort((a, b) => {
      const aDt = a.history.at(-1).dt;
      const bDt = b.history.at(-1).dt;
      if (aDt < bDt) {
        return 1;
      }
      if (aDt > bDt) {
        return -1;
      }
      return 0;
    });
    setSortedChats(newChats);
  }, [allChats]);

  return (
    <Stack
      direction="column"
      sx={{
        // width: "150px",
        // px: 1,
        ...FontStyle.body,
        borderRight: "1px solid #ddd",
        paddingTop: 4,
        backgroundColor: "#fff",
      }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={1}
        sx={{
          ...FontStyle.headingBody,
          fontSize: "20px",
          px,
          paddingBottom: 2,
        }}>
        <img
          src={chatIcon}
          alt="chat"
          style={{ width: "22px", height: "22px" }}
        />
        <Box>Messages</Box>
      </Stack>
      <Box
        sx={{
          px: 1,
        }}>
        {isScrolled && (
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#ddd",
              width: "100%",
            }}
          />
        )}
      </Box>
      <Stack
        direction="column"
        onScroll={(e) => {
          // set isScrolled if scroll position is not at top
          if (e.target.scrollTop > 0) {
            setIsScrolled(true);
          } else {
            setIsScrolled(false);
          }
        }}
        sx={{
          width: "100%",
          backgroundColor: "#fff",
          px: 1,
          flex: 1,
          // height: "100%",
          overflowY: "auto",
          // borderTop: isScrolled ? "1px solid #ddd" : "none",
        }}>
        {sortedChats.map((chat, index) => {
          return <SidebarChatPreview key={index} chat={chat} index={index} />;
        })}
      </Stack>
    </Stack>
  );
};

export default MessagesSidebar;
